module.exports = __webpack_public_path__ + "./images/53992a3da24fd7b25ccd1c3e1942c979.webp";